var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locale-switcher"},[_c('v-row',[_c('v-btn',{attrs:{"icon":"","value":_vm.$i18n.locale},on:{"click":_vm.changeLocale}},[_vm._v(" "+_vm._s(_vm.$i18n.locale)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }